import _toConsumableArray from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import { useRef, useState } from 'react';
import styled from 'styled-components';
import { styleVariables } from '@lib/common';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
// Re-use the same color palette
var STATUS_STYLE = {
  '5': {
    dot: '#FA8C16',
    activeBg: '#FFF7E6',
    activeBorder: '#FFD591',
    activeColor: '#FA8C16'
  },
  '6': {
    dot: '#1A5AFF',
    activeBg: '#E6F2FF',
    activeBorder: '#1A5AFF',
    activeColor: '#1A5AFF'
  },
  '7': {
    dot: '#9254DE',
    activeBg: '#F9F0FF',
    activeBorder: '#B37FEB',
    activeColor: '#9254DE'
  },
  '8': {
    dot: '#3A8814',
    activeBg: '#E8FCD5',
    activeBorder: '#52C41A',
    activeColor: '#3A8814'
  }
};
var ALL_STATUS_ID = '';
// ─── Styled components ────────────────────────────────────────────────────────
var StyledWrapper = styled.div.withConfig({
  displayName: "status-filter-dropdowncomponent__StyledWrapper",
  componentId: "sc-1jw796h-0"
})(["position:relative;display:inline-block;"]);
var StyledTrigger = styled.button.withConfig({
  displayName: "status-filter-dropdowncomponent__StyledTrigger",
  componentId: "sc-1jw796h-1"
})(["display:inline-flex;align-items:center;gap:8px;height:50px;padding:0 16px;border-radius:10px;border:1.5px solid ", ";background:", ";color:", ";font-size:13px;font-weight:", ";cursor:pointer;transition:all 0.15s ease;white-space:nowrap;user-select:none;&:hover{border-color:", ";color:", ";background:", ";}"], function (_ref) {
  var $active = _ref.$active;
  return $active ? styleVariables.colors.blue3 : styleVariables.colors.grey14;
}, function (_ref2) {
  var $active = _ref2.$active;
  return $active ? styleVariables.colors.blue1 : '#ffffff';
}, function (_ref3) {
  var $active = _ref3.$active;
  return $active ? styleVariables.colors.blue3 : styleVariables.colors.grey100;
}, function (_ref4) {
  var $active = _ref4.$active;
  return $active ? 600 : 400;
}, styleVariables.colors.blue3, styleVariables.colors.blue3, styleVariables.colors.blue1);
var StyledBadge = styled.span.withConfig({
  displayName: "status-filter-dropdowncomponent__StyledBadge",
  componentId: "sc-1jw796h-2"
})(["display:inline-flex;align-items:center;justify-content:center;min-width:18px;height:18px;padding:0 5px;border-radius:9px;background:", ";color:#ffffff;font-size:11px;font-weight:700;line-height:1;"], styleVariables.colors.blue3);
var StyledChevron = styled.span.withConfig({
  displayName: "status-filter-dropdowncomponent__StyledChevron",
  componentId: "sc-1jw796h-3"
})(["display:inline-flex;transition:transform 0.15s ease;transform:", ";opacity:0.6;"], function (_ref5) {
  var $open = _ref5.$open;
  return $open ? 'rotate(180deg)' : 'rotate(0deg)';
});
var StyledPanel = styled.div.withConfig({
  displayName: "status-filter-dropdowncomponent__StyledPanel",
  componentId: "sc-1jw796h-4"
})(["position:absolute;top:calc(100% + 6px);right:0;z-index:1000;min-width:200px;background:#ffffff;border:1px solid ", ";border-radius:10px;box-shadow:0 6px 24px rgba(0,0,0,0.1);padding:6px 0;overflow:hidden;"], styleVariables.colors.grey14);
var StyledPanelItem = styled.button.withConfig({
  displayName: "status-filter-dropdowncomponent__StyledPanelItem",
  componentId: "sc-1jw796h-5"
})(["display:flex;align-items:center;gap:10px;width:100%;padding:8px 16px;border:none;background:", ";color:", ";font-size:13px;font-weight:", ";cursor:pointer;text-align:left;transition:background 0.12s ease,color 0.12s ease;&:hover{background:", ";color:", ";}"], function (_ref6) {
  var $active = _ref6.$active,
      $activeBg = _ref6.$activeBg;
  return $active ? $activeBg : 'transparent';
}, function (_ref7) {
  var $active = _ref7.$active,
      $activeColor = _ref7.$activeColor;
  return $active ? $activeColor : styleVariables.colors.grey100;
}, function (_ref8) {
  var $active = _ref8.$active;
  return $active ? 600 : 400;
}, function (_ref9) {
  var $activeBg = _ref9.$activeBg;
  return $activeBg;
}, function (_ref10) {
  var $activeColor = _ref10.$activeColor;
  return $activeColor;
});
var StyledDot = styled.span.withConfig({
  displayName: "status-filter-dropdowncomponent__StyledDot",
  componentId: "sc-1jw796h-6"
})(["width:8px;height:8px;border-radius:50%;background-color:", ";flex-shrink:0;"], function (_ref11) {
  var $color = _ref11.$color;
  return $color;
});
var StyledCheck = styled.span.withConfig({
  displayName: "status-filter-dropdowncomponent__StyledCheck",
  componentId: "sc-1jw796h-7"
})(["margin-left:auto;opacity:", ";font-size:12px;color:inherit;"], function (_ref12) {
  var $visible = _ref12.$visible;
  return $visible ? 1 : 0;
});
var StyledDivider = styled.hr.withConfig({
  displayName: "status-filter-dropdowncomponent__StyledDivider",
  componentId: "sc-1jw796h-8"
})(["margin:6px 0;border:none;border-top:1px solid ", ";"], styleVariables.colors.grey14);
var StyledClearBtn = styled.button.withConfig({
  displayName: "status-filter-dropdowncomponent__StyledClearBtn",
  componentId: "sc-1jw796h-9"
})(["display:block;width:100%;padding:6px 16px;border:none;background:transparent;color:", ";font-size:12px;font-weight:500;cursor:pointer;text-align:left;&:hover{text-decoration:underline;}"], styleVariables.colors.blue3); // ─── Chevron SVG ─────────────────────────────────────────────────────────────

var ChevronIcon = function ChevronIcon() {
  return /*#__PURE__*/_jsx("svg", {
    width: "12",
    height: "12",
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsx("path", {
      d: "M2 4L6 8L10 4",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })
  });
}; // ─── Component ────────────────────────────────────────────────────────────────


export var StatusFilterDropdown = function StatusFilterDropdown(_ref13) {
  var options = _ref13.options,
      selectedIds = _ref13.selectedIds,
      onChange = _ref13.onChange,
      labels = _ref13.labels;

  var _useState = useState(false),
      open = _useState[0],
      setOpen = _useState[1];

  var wrapperRef = useRef(null); // Close on outside click

  var handleBlur = function handleBlur(e) {
    var _wrapperRef$current;

    if (!((_wrapperRef$current = wrapperRef.current) !== null && _wrapperRef$current !== void 0 && _wrapperRef$current.contains(e.relatedTarget))) {
      setOpen(false);
    }
  };

  var isAllSelected = selectedIds.length === 0;
  var activeCount = selectedIds.length;
  var isActive = !isAllSelected;

  var toggleId = function toggleId(id) {
    if (selectedIds.includes(id)) {
      var next = selectedIds.filter(function (s) {
        return s !== id;
      });
      onChange(next);
    } else {
      onChange([].concat(_toConsumableArray(selectedIds), [id]));
    }
  };

  var handleSelectAll = function handleSelectAll() {
    onChange([]);
    setOpen(false);
  };

  var handleClear = function handleClear() {
    onChange([]);
  };

  return /*#__PURE__*/_jsxs(StyledWrapper, {
    ref: wrapperRef,
    onBlur: handleBlur,
    tabIndex: -1,
    children: [/*#__PURE__*/_jsxs(StyledTrigger, {
      type: "button",
      $active: isActive,
      onClick: function onClick() {
        return setOpen(function (v) {
          return !v;
        });
      },
      "aria-haspopup": "listbox",
      "aria-expanded": open,
      children: [labels.triggerLabel, isActive && /*#__PURE__*/_jsx(StyledBadge, {
        children: activeCount
      }), /*#__PURE__*/_jsx(StyledChevron, {
        $open: open,
        children: /*#__PURE__*/_jsx(ChevronIcon, {})
      })]
    }), open && /*#__PURE__*/_jsxs(StyledPanel, {
      role: "listbox",
      children: [/*#__PURE__*/_jsxs(StyledPanelItem, {
        type: "button",
        $active: isAllSelected,
        $activeBg: styleVariables.colors.blue1,
        $activeColor: styleVariables.colors.blue3,
        $activeBorder: styleVariables.colors.blue3,
        onClick: handleSelectAll,
        role: "option",
        "aria-selected": isAllSelected,
        children: [labels.all, /*#__PURE__*/_jsx(StyledCheck, {
          $visible: isAllSelected,
          children: "\u2713"
        })]
      }), /*#__PURE__*/_jsx(StyledDivider, {}), options.map(function (option) {
        var _STATUS_STYLE$option$;

        var style = (_STATUS_STYLE$option$ = STATUS_STYLE[option.id]) !== null && _STATUS_STYLE$option$ !== void 0 ? _STATUS_STYLE$option$ : {
          dot: styleVariables.colors.blue2,
          activeBg: styleVariables.colors.blue1,
          activeBorder: styleVariables.colors.blue3,
          activeColor: styleVariables.colors.blue3
        };
        var isChecked = selectedIds.includes(option.id);
        return /*#__PURE__*/_jsxs(StyledPanelItem, {
          type: "button",
          $active: isChecked,
          $activeBg: style.activeBg,
          $activeColor: style.activeColor,
          $activeBorder: style.activeBorder,
          onClick: function onClick() {
            return toggleId(option.id);
          },
          role: "option",
          "aria-selected": isChecked,
          children: [/*#__PURE__*/_jsx(StyledDot, {
            $color: style.dot
          }), option.label, /*#__PURE__*/_jsx(StyledCheck, {
            $visible: isChecked,
            children: "\u2713"
          })]
        }, option.id);
      }), isActive && /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(StyledDivider, {}), /*#__PURE__*/_jsx(StyledClearBtn, {
          type: "button",
          onClick: handleClear,
          children: "\u2715 Clear filter"
        })]
      })]
    })]
  });
};